<template>
  <div class="authority">
    <el-row :gutter="20"  class="images">
      <el-col :xs="24" :span="6" :lg="12" :md="12" :xl="6" class="image" v-for="(item,index) in images" :key="index">
        <el-image :preview-src-list="imageSrcList" fit="contain" :src="item.url" lazy/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Authority",
  mounted() {
    this.imageSrcList = this.images.map(item=>item.url)
  },
  data(){
    return{
      images:[
        {url:require('../../assets/images/certification/authority/智充大数据企业.jpg')},
        {url:require('../../assets/images/certification/authority/软件产品证书.jpg')},
        {url:require('../../assets/images/certification/authority/软件企业证书.jpg')},
        {url:require('../../assets/images/certification/authority/高新技术企业.jpg')}
      ],
      imageSrcList:[]
    }
  }
}
</script>

<style lang="less" scoped>
.authority{
  box-sizing: border-box;
  padding: 0 20px;
  text-align: center;
  width: 100%;
  .images {
    margin: 5px 0;
    .image {
      font-size: 28px;
      display: inline-block;
      .el-image{
        margin: 5px 20px;
        width: 360px;
      }
    }
  }
}
</style>
